import { render, staticRenderFns } from "./EditTransactionModal.vue?vue&type=template&id=60312600&"
import script from "./EditTransactionModal.vue?vue&type=script&lang=ts&"
export * from "./EditTransactionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports